import { isNonNullable } from 'js/types/isNonNullable';

/**
 * Returns the given `array` with all undefined and/or null elements removed in a type safe manner.
 */
export function arrayWithoutNullables<T>(array: T[]): NonNullable<T>[] {
  return array.filter(isNonNullable);
}
